// document.getElementById('size-chart-btn').addEventListener('click', function() {
//   document.getElementById('size-chart-slider').style.display = 'flex';
// });

// document.getElementById('close-slider').addEventListener('click', function() {
//   document.getElementById('size-chart-slider').style.display = 'none';
// });

// // Optional: Add background click to close
// document.getElementById('size-chart-slider').addEventListener('click', function(event) {
//   if (event.target === this) {
//     this.style.display = 'none';
//   }
// });

document.getElementById('size-chart-btn').addEventListener('click', function() {
  const slider = document.getElementById('size-chart-slider');
  slider.classList.add('active'); // Add active class to trigger slide in
});

document.getElementById('close-slider').addEventListener('click', function() {
  const slider = document.getElementById('size-chart-slider');
  slider.classList.remove('active'); // Remove active class to trigger slide out
});

// Optional: Add background click to close
document.getElementById('size-chart-slider').addEventListener('click', function(event) {
  if (event.target === this) {
    this.classList.remove('active'); // Close the slider
  }
});